/* eslint-disable react/require-default-props */
import {Outlet, useNavigate, useSearchParams} from "react-router-dom"
import Container from '@mui/material/Container';
import {useEffect} from "react";
import {DataStoreContextProvider} from "../contexts/OperatingTestContext";
import OperatingTestFuncTab from "../components/OperatingTestFuncTab";
import {DISP_MODE, URL_PARAMS} from "../../../constants/constants";
import {ROLE_KEYS, useUserRole} from "../../../utils/awsConfigure";

export default function OperatingTestLayout() {
  const [searchParams] = useSearchParams();
  const isPopupMode = !!(searchParams.get(URL_PARAMS.DISP_MODE) && searchParams.get(URL_PARAMS.DISP_MODE) === DISP_MODE.POPUP);
  const { userRole } = useUserRole();
  const navigate = useNavigate();
  useEffect(()=>{
    if(userRole===ROLE_KEYS.RETAILER){
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (
    <DataStoreContextProvider>
      {!isPopupMode && <OperatingTestFuncTab/>}
      <Container sx={{
        mx: 0,
        pb: 3,
        pt: 0,
        width: "100%",
        backgroundColor: 'white',
        maxWidth: "unset!important", ...(isPopupMode ? {p: "0 !important"} : {})
      }}>
        <Container sx={{mx: 0, pb: 3, pt: 1, width: "100%", backgroundColor: '#F6F7F8', maxWidth: "unset!important"}}>
          <Outlet/>
        </Container>
      </Container>
    </DataStoreContextProvider>
  )
}
